"use client"

import { useEffect } from "react"
import { captureException } from "@/lib/analytics/posthog"
import { ErrorView } from "@/components/error/error-view"

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // React render errors are caught by this boundary and never reach
    // window.onerror, so PostHog autocapture misses them - report explicitly.
    captureException(error, { boundary: "app/error", digest: error.digest })
  }, [error])

  return <ErrorView error={error} reset={reset} />
}
